// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Description_wrap__fOKMx","text":"Description_text__oGr8D"};